import React from 'react';
import { Shield, Clock, CheckCircle } from 'lucide-react';

const GuaranteeSection = () => {
  const pledgeItems = [
    "If you don't save at least 5 hours per week on admin tasks, we'll extend your subscription for free",
    "If client feedback doesn't improve within 60 days, our team will help optimize your setup at no extra cost",
    "Priority support throughout your onboarding to ensure a smooth transition"
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-emerald-50">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <div className="flex items-center justify-center mb-6">
          <Shield className="w-14 h-14 text-emerald-600" strokeWidth={1.5} />
        </div>
        <h2 className="text-4xl font-bold mb-5">Our Risk-Free Guarantee</h2>
        <p className="text-xl text-gray-700 mb-16 max-w-3xl mx-auto leading-relaxed">
          We're so confident in our platform that we offer the strongest guarantee in the industry.
        </p>
        
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div className="flex flex-col items-center text-center border-b border-emerald-100 pb-8">
            <Clock className="w-14 h-14 text-emerald-600 mb-6" strokeWidth={1.5} />
            <h3 className="text-2xl font-semibold mb-4">14-Day Free Trial</h3>
            <p className="text-gray-700 text-lg">
              Try every feature of our platform for 14 days with no credit card required. Experience the full power of our system risk-free.
            </p>
          </div>
          
          <div className="flex flex-col items-center text-center border-b border-emerald-100 pb-8">
            <CheckCircle className="w-14 h-14 text-emerald-600 mb-6" strokeWidth={1.5} />
            <h3 className="text-2xl font-semibold mb-4">30-Day Money-Back Promise</h3>
            <p className="text-gray-700 text-lg">
              After your free trial, you're still protected by our 30-day money-back guarantee. No questions asked if you're not completely satisfied.
            </p>
          </div>
        </div>
        
        <div className="mb-16 max-w-3xl mx-auto">
          <h3 className="text-2xl font-semibold mb-8">Our Coaching Success Pledge</h3>
          <div className="space-y-6 text-left">
            {pledgeItems.map((item, index) => (
              <div key={index} className="flex items-start">
                <div className="text-emerald-600 mr-4 mt-1 text-xl">✓</div>
                <p className="text-lg text-gray-700">{item}</p>
              </div>
            ))}
          </div>
        </div>
        
        <a 
          href="https://calendly.com/usekinos" 
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-black text-white px-10 py-5 rounded-xl text-xl font-medium hover:bg-emerald-600 transition-all duration-300"
        >
          Get Started Risk-Free Today
        </a>
        
        <p className="mt-6 text-gray-600 text-base">
          No long-term contracts • Cancel anytime • Your satisfaction is our priority
        </p>
      </div>
    </section>
  );
};

export default GuaranteeSection;